import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { Store, useAppDispatch } from 'src/redux/Store';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import FormTextField from 'src/components/Control/FormControls/FormTextField';
import { FORM } from 'src/constants/Form';
import { useState } from 'react';
import { LoginData } from 'src/apis/UserAPI';
import { logUserAction } from 'src/redux/actions/userActions';

const useStyles = makeStyles(() => ({
  row: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  title: {
    fontWeight: 'bold',
    width: '172px',
  },
}));

const LoginDialog = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const [payload, setPayload] = useState({
    email: '',
    password: '',
  } as LoginData);

  const opened =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.login]) {
        return state.dialog[DIALOGS.login].opened;
      }
      return false;
    });

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.login }));
  };

  const handleOk = () => {
    dispatch(logUserAction(payload));
  };

  const handleOnChange = (value: Value, field: string) => {
    setPayload({
      ...payload,
      [field]: value,
    });
  };

  return (
    <Dialog
      aria-labelledby="change-password"
      open={opened}
      maxWidth="sm"
      PaperProps={{
        style: {
          width: '100%',
        },
      }}>
      <DialogTitle id="change-password">Login</DialogTitle>
      <DialogContent dividers>
        <div className={classes.row}>
          <span className={classes.title}>Email:</span>
          <FormTextField
            form={FORM.login}
            label="Email"
            name="email"
            onChange={handleOnChange}
            required
            value={payload.email}
            margin="dense" />
        </div>
        <div className={classes.row}>
          <span className={classes.title}>Password:</span>
          <FormTextField
            form={FORM.login}
            label="Password"
            name="password"
            onChange={handleOnChange}
            required
            value={payload.password}
            margin="dense"
            type="password" />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginDialog;
